import { UrlList } from '@/types';

//@ts-ignore
const urls: UrlList = window.measurementData.urls;

const baseUrl = urls.baseUrl;
const defaultImageUrl = urls.defaultImageUrl;

export function getImage(imageUrl: string) {
	if (imageUrl == null) {
		return `${baseUrl}${defaultImageUrl}`;
	}

	return `${baseUrl}${imageUrl}`;
}
